import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const NewRequestIcon = forwardRef<SVGSVGElement, Props>((props, ref) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="16"
			height="16"
			{...props}
			ref={ref}
			viewBox="0 0 16 16"
			fill="currentColor"
		>
			<path d="M7.27637 1.24445C7.67605 1.24445 8.00007 1.56861 8.00018 1.96826C8.00018 2.368 7.67612 2.69206 7.27637 2.69206H4.86368C3.66452 2.69206 2.69236 3.66432 2.69225 4.86349V11.1365C2.69225 12.3357 3.66443 13.3079 4.86368 13.3079H11.1367C12.3359 13.3079 13.3081 12.3357 13.3081 11.1365V8.72381C13.3082 8.32416 13.6323 8 14.0319 8C14.4316 8 14.7556 8.32416 14.7557 8.72381V11.1365C14.7557 13.1353 13.1355 14.7556 11.1367 14.7556H4.86368C2.86493 14.7556 1.24463 13.1353 1.24463 11.1365V4.86349C1.24474 2.86486 2.86499 1.24445 4.86368 1.24445H7.27637Z" />
			<path d="M13.2579 1.50147C13.6007 1.1588 14.1563 1.15875 14.4989 1.50147C14.8413 1.84421 14.8415 2.39999 14.4989 2.74262L9.24933 7.99184C8.71779 8.52332 8.01017 8.8424 7.25995 8.88864C7.17612 8.89361 7.10651 8.82412 7.11159 8.74026C7.1579 7.99001 7.4769 7.28226 8.00831 6.75069L13.2579 1.50147Z" />
		</svg>
	)
})
